import { Form, Button } from "react-bootstrap";
import { Link, useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import HttpStatus from "./../helpers/status.enum";
import { checkInActions } from "./../store/checkin.slice";
import { activityLogActions } from "./../store/activityLog.slice";
import { logActivity } from "../helpers/activity-logger";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState, useRef } from "react";
import Datepicker from "../assets/components/datepicker";
import Moment from "moment";
import SpinnerLoader from "../components/SpinnerLoader";
import Modal from "react-bootstrap/Modal";
import {
  generateSlug,
} from "../config/functions";
import fallback1 from ".././assets/images/fallbackimg1.avif"
import fallback2 from ".././assets/images/fallbackimg2.avif"
import fallback3 from ".././assets/images/fallbackimg3.avif"
import fallback4 from ".././assets/images/fallbackimg4.avif"
import fallback5 from ".././assets/images/fallbackimg5.avif"

function Welcome({ checkedInPageHandle, checkingPageHandle, reservationPageHandle }) {
  const dispatch = useDispatch();
  const startTime = 120; // 2 minutes in seconds
  /*
  Handle two URL patterns:
    1. domain/:listingSlug/:bookingSlug
    2. domain/:bookingSlug

    Note: listingSlug could be bookingSlug if 2nd url hit.
  */
  const { listingSlug, bookingSlug } = useParams();
  const location = useLocation();

  const [checkinDate, setCheckinDate] = useState(null);
  const [checkoutDate, setCheckoutDate] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [hostName, setHostName] = useState("");
  const [hostLogo, setHostLogo] = useState(null);
  const [showWelcomeScreen, setShowWelcomeScreen] = useState(false);
  const [showotpModal, setotpModal] = useState(false);
  const [timer, setTimer] = useState(0);
  const [otpInputs, setOtpInputs] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const [userInputOtp, setUserInputOtp] = useState(null);
  const [isFormValidOTP, setIsFormValidOTP] = useState(false);
  const [isOTPLoading, setIsOTPLoading] = useState(false);
  const [postCheckinInfo, setPostCheckinInfo] = useState({});
  const [bookingInfo, setbookingInfo] = useState({});
  const [checkinToken, setCheckinToken] = useState("");
  const [shouldSubmit, setShouldSubmit] = useState(false);

  const videoRef = useRef(null);
  const videoRefMobile = useRef(null);
  const [showFallback, setShowFallback] = useState(false);
   // Function to parse query parameters
   const getQueryParams = (search) => {
    return new URLSearchParams(search);
  };

  // Populate checkIn.listingSlug from the URL synchronously, before any API call
  // resolves, so every activity log fired on this page (even ones that fire
  // immediately on mount) always has a listing_slug -- not dependent on network timing.
  useEffect(() => {
    if (listingSlug) {
      dispatch(checkInActions.setListingSlugCode(listingSlug));
    }
    // Starts a fresh guest-journey session id every time the welcome page is loaded.
    dispatch(activityLogActions.setSessionId(crypto.randomUUID()));
  }, []);

  useEffect(() => {
    const queryParams = getQueryParams(location.search);
    const checkin = queryParams.get('checkin');
    const checkout = queryParams.get('checkout');
    const token = queryParams.get('token');
    const source = queryParams.get('source');
    if (checkin && checkout) {
      setCheckinDate(new Date(checkin));
      setCheckoutDate(new Date(checkout));
      setCheckinToken(token);
    } else {
      fetchData();
    }
    if (source === 'mail' || source === 'sms') {
      logActivity("early_checkin_link_clicked", { source, booking_slug: bookingSlug ?? listingSlug });
    }
    // fetching host details
    fetchHostDetails();
  }, [location.search]);

  const onCheckinDateChange = (date) => {
    setCheckinDate(date);
  };

  const onCheckoutDateChange = (date) => {
    setCheckoutDate(date);
  };

  const onCheckinDateClear = () => {
    setIsDisabled(true);
    setCheckinDate(null);
  }

  const onCheckoutDateClear = () => {
    setIsDisabled(true);
    setCheckoutDate(null);
  }

  useEffect(() => {
    if (checkinDate !== null && checkoutDate !== null) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [checkinDate, checkoutDate]);

  const submitHandler = async (event) => {
    if(event){
      event.preventDefault();
    }
    setIsDisabled(true);
    setIsLoading(true);
    const formData = {
      "slug": listingSlug,
      "checkin_date": Moment(checkinDate).format("YYYY-MM-DD"),
      "checkout_date": Moment(checkoutDate).format("YYYY-MM-DD"),
      "is_otp_required": true,
      "token": checkinToken,
    };

    const result = await dispatch(
      checkInActions.getBookingInfo(formData)
    );
    const data = result?.payload || null;

    if (data?.status === HttpStatus.HTTP_OK) {
      const possibleBookingSlug = bookingSlug ?? listingSlug;
      const isNumericOnly = /^\d+$/.test(possibleBookingSlug ?? "");
      logActivity(
        "begin_check_in",
        {
          ...(isNumericOnly ? {} : { booking_slug: possibleBookingSlug }),
          checkin_date: checkinDate ? Moment(checkinDate).format("YYYY-MM-DD") : null,
          checkout_date: checkoutDate ? Moment(checkoutDate).format("YYYY-MM-DD") : null,
        }
      );
      if (!localStorage.getItem('system-id')) {
        localStorage.setItem('system-id', generateSlug(20));
      }
      const records = data?.result;
      setbookingInfo(records);
      localStorage.setItem('charge-otp-text', records?.listing_alert?.checkin_otp);
      if (records?.is_otp_required === 1) {
        let otpData = records?.otp_data || {};
        if(otpData?.error) {
          toast(otpData?.error);
          setIsDisabled(false);
          setIsLoading(false);
        } else {
          setPostCheckinInfo(otpData);
          openOtpModel();
        }
      } else {
        if (records?.isCheckinCompleted === true) {
          reservationPageHandle(true);
          checkingPageHandle(false);
          checkedInPageHandle(false);
          // navigate("/reservationinfo");
        } else if (records?.is_continue_accepted === 1) {
            checkingPageHandle(true);
            checkedInPageHandle(false);
            // navigate("/checkingin");
        } else {
          checkedInPageHandle(true);
          // navigate("/checkedin");
        }
     }
    } else {
      checkedInPageHandle(false);
      toast(data?.message);
      setIsDisabled(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
  if (
    shouldSubmit &&
    checkinDate &&
    checkoutDate
  ) {
    submitHandler();
    setShouldSubmit(false); // prevent re-trigger
  }
}, [checkinDate, checkoutDate, shouldSubmit]);

const apiDateToDate = (dateStr) => {
  if (!dateStr) return null;
  return new Date(dateStr + 'T12:00:00'); // noon avoids -1 day issue
};

  const fetchData = async () => {
    // Here it must be booking slug
    const formData = {
      booking_slug: bookingSlug ?? listingSlug,
      from_sms: true,
    };
    const result = await dispatch(checkInActions.getBookingByCode(formData));
    if (result?.payload?.status === HttpStatus.HTTP_OK) {
      setCheckinDate(apiDateToDate(result?.payload?.result?.checkin_date));
      setCheckoutDate(apiDateToDate(result?.payload?.result?.checkout_date));
      setShouldSubmit(true);
    }
  }

  const fetchHostDetails = async () => {
    try {
      const formData = { slug: listingSlug }; // listingSlug could be reservationSlug due short url change.
      const result = await dispatch(checkInActions.getHostDetails(formData));
      if (result?.payload?.status === HttpStatus.HTTP_OK) {
        const records = result?.payload?.result;
        if (records?.name) {
          setHostName(records?.name);
        }
        if (records?.image) {
          setHostLogo(records?.image);
        }
      } 
    } catch (e) {
      console.error("Error fetching host details", e);
    } finally {
      setShowWelcomeScreen(true) // After this screen will visible to user
    }
  }

  const openOtpModel = () => {
    setotpModal(true);
    setTimer(startTime);
    setOtpInputs(["", "", "", "", "", ""]);
  }

  const closeOtpModel = () => {
    setotpModal(false);
    setIsDisabled(false);
    setIsLoading(false);
    setOtpInputs(["", "", "", "", "", ""]);
  }

  const handleOtpInputChange = (index, value) => {
    // Check if the value is a single digit number
    if (/^\d$/.test(value) || value === "") {
      const updatedOtpInputs = [...otpInputs];
      updatedOtpInputs[index] = value;
      setOtpInputs(updatedOtpInputs);

      // Move focus to the previous input field if the value is deleted
      if (value === "" && index > 0) {
        inputRefs.current[index - 1].focus();
      } else {
        // Move focus to the next input field if available
        if (index < inputRefs.current.length - 1 && value.trim() !== "") {
          inputRefs.current[index + 1].focus();
        }
      }

      // Check if all OTP inputs are filled
      const allInputsFilled = updatedOtpInputs.every(
        (input) => input.trim() !== ""
      );
      setIsFormValidOTP(allInputsFilled);
      const userInputOtp = updatedOtpInputs.join("");
      setUserInputOtp(userInputOtp);
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text");

    if (pastedData.length === otpInputs.length && /^\d+$/.test(pastedData)) {
      // Only 6 digits opt to paste in form
      const updatedOtpInputs = pastedData.split("");
      setOtpInputs(updatedOtpInputs);
      setIsFormValidOTP(true);
      setUserInputOtp(pastedData);

      inputRefs.current[otpInputs.length - 1].focus();
    }
  };

  useEffect(() => {
    let interval;
    if (showotpModal && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1); // Decrease by 1 second
      }, 1000);
    } else {
      clearInterval(interval); // Stop the timer if timer reach 0
    }

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [showotpModal, timer]);

  
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsOTPLoading(true);
    setIsFormValidOTP(false);
    const formData = {
      verification_code: userInputOtp,
      is_resend: 0,
      auth_code: postCheckinInfo?.auth_code,
      booking_slug: bookingInfo?.booking_slug,
    };
    try {
      const result = await dispatch(checkInActions.verifyPostInfoOtp(formData));
      const data = result?.payload || null;
      toast(data?.message);
      if (data?.status === HttpStatus.HTTP_OK) {
        setIsDisabled(false);
        if (bookingInfo?.isCheckinCompleted === true) {
          reservationPageHandle(true);
          checkingPageHandle(false);
          checkedInPageHandle(false);
        } else if (bookingInfo?.is_continue_accepted === 1) {
            checkingPageHandle(true);
            checkedInPageHandle(false);
        } else {
          checkedInPageHandle(true);
        }
      } else {
        setIsOTPLoading(false);
        setIsFormValidOTP(true);
      }
    } catch (error) {
      setIsOTPLoading(false);
      console.error("Error occurred while submitting form:", error);
      return false;
    } finally {
      setIsOTPLoading(false);
    }
  };

  const handleResendOTP = async (event) => {
    setIsFormValidOTP(false);
    event.preventDefault();
    const formData = {
      verification_code: "",
      is_resend: 1,
      auth_code: postCheckinInfo?.auth_code,
      booking_slug: bookingInfo?.booking_slug,
    };
    try {
      const result = await dispatch(checkInActions.verifyPostInfoOtp(formData));
      const data = result?.payload || null;
      if (data?.status === HttpStatus.HTTP_OK) {
        setOtpInputs(["", "", "", "", "", ""]);
        setTimer(startTime);
      }
      toast(data?.message);
    } catch (error) {
      console.error("Error occurred while submitting form:", error);
    }
  };

  const themeName = localStorage.getItem('theme') || 'theme1';

  const themeVideoMap = {
    theme1: 'welcome-bg.webm',
    theme3: 'New-Chalet-1-and-2-Video.webm',
    theme4: 'New-Chalet-3-Video.webm',
    theme5: 'New-Chalet-4-Video.webm',
    theme6: 'New-Chalet-4-Video.webm',
    theme7: 'New-Chalet-4-Video.webm',
    theme8: 'Cape_Cod_1_Slower.webm',
    theme10:'New-Chalet-1-and-2-Video.webm',
    theme11:'New-Chalet-1-and-2-Video.webm',
    theme12:'welcome-bg.webm'
  };

  const themeFallbackImageMap = {
    theme1: fallback2,
    theme3: fallback3,
    theme4: fallback1,
    theme5: fallback5,
    theme6: fallback5,
    theme7: fallback5,
    theme8: fallback4,
    theme10: fallback3,
    theme11: fallback3,
    theme12: fallback2,
  };
  // fallback to theme1 if theme not found
  const videoFile = themeVideoMap[themeName] || themeVideoMap.theme1;

  const videoSrc = `${process.env.REACT_APP_AWS_CLOUD_FRONT_URL}/Stream_Videos/${videoFile}`;
  
  const fallbackImageSrc = themeFallbackImageMap[themeName] || themeFallbackImageMap.theme1;

  // Try to play video, show fallback only if not playing after 10 seconds
  useEffect(() => {
    const tryPlayVideo = (video) => {
      if (!video) return;
      video.play().catch(() => {});
    };

    tryPlayVideo(videoRef.current);
    tryPlayVideo(videoRefMobile.current);

    const timeout = setTimeout(() => {
      const desktop = videoRef.current;
      const mobile = videoRefMobile.current;
      const desktopFailed = desktop && (desktop.paused || desktop.readyState < 3);
      const mobileFailed = mobile && (mobile.paused || mobile.readyState < 3);
      if (desktopFailed && mobileFailed) {
        setShowFallback(true);
      }
    }, 10000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <section className={`welcomePage ${showFallback ? 'fallback-active' : ''}`}>
      <div className="content">
        
        <div className="w-100 p-2">
        <h2 className="text-center text-white mb-3">{hostName}</h2>
        <span className="text-center">
          <figure className="hostLogo">
            {hostLogo ? (
                <img
                  className='image_uploaded'
                  src={hostLogo}
                  alt="guest-welcome"
                />
            ) : (
              ' '
            )}
          </figure>
        </span>
          <h1 id="welcometext"></h1>
          <h4>You're gonna have a great stay :)</h4>
          <Form onSubmit={submitHandler}>
            <Form.Group className="mb-3 mt-4" controlId="checkInDate">
              <Datepicker onCheckinDateChange={onCheckinDateChange} onCheckoutDateChange={onCheckoutDateChange} onCheckinDateClear={onCheckinDateClear} onCheckoutDateClear={onCheckoutDateClear} paramCheckinDate={checkinDate} paramCheckoutDate={checkoutDate} />
            </Form.Group>
            <Button
              className="fillbuttonwhite"
              type="submit"
              disabled={isDisabled ? true : false}
            >
              {isLoading ? (<><SpinnerLoader /></>) : ("Begin Check In")}
            </Button>
          </Form>
          {/* <h6 className="text-center mt-3"><Link to="#" className="text-overline2 text-white">Have you confirmation code?</Link></h6> */}
        </div>
      </div>
      {/* <div className="welcomebg">
        <div className="overlay"></div>
      </div> */}
      <div className="welcomebgvideo">
          {showFallback ? (
            <img
              src={fallbackImageSrc}
              alt="Preview"
              className="bg-media"
            />
          ) : (
            <video ref={videoRef} autoPlay muted playsInline loop preload="auto" id="video">
              <source src={videoSrc} type="video/webm" />
            </video>
          )}
      </div>
      <div className="welcomebgvideomobile">
        {showFallback ? (
          <div className="logo-wrapper">
            <img
              src={fallbackImageSrc}
              alt="Preview"
              className="bg-media"
            />
          </div>
        ) : (
            <video ref={videoRefMobile} autoPlay muted playsInline loop preload="auto" id="video">
              <source src={videoSrc} type="video/webm" />
            </video>
        )}
        </div>

     {/* OTP Modalbox */}
      <Modal
        show={showotpModal}
        onHide={closeOtpModel}
        dialogClassName="modal-90w modal-bottom"
        aria-labelledby="example-custom-modal-styling-title"
        className="otp-modal"
        backdrop="static"
        // maskClosable={false}
      >
        <Modal.Header closeButton onClick={closeOtpModel}></Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <h2 className="mb-2">Verification</h2>
            <h6 className="mb-2 pb-2" dangerouslySetInnerHTML={{
                      __html: `${postCheckinInfo?.otp_description}`,
              }}></h6>
            <Form.Group className="mb-4" controlId="otpnumber">
              <div className="d-flex justify-content-center gap-2">
                {otpInputs.map((input, index) => (
                  <Form.Control
                    key={index}
                    type="tel" // Use type="text" to prevent number type validation
                    className="input-text-otp"
                    value={input}
                    onChange={(e) =>
                      handleOtpInputChange(index, e.target.value)
                    }
                    maxLength={1} // Limit input length to 1 character
                    ref={(ref) => (inputRefs.current[index] = ref)} // Ref for the input field
                    required
                    onPaste={index === 0 ? handleOtpPaste : null}
                  />
                ))}
              </div>
              {/* <Form.Text className="text-danger">{otpError}</Form.Text> */}
            </Form.Group>

            <div className="d-flex justify-content-center">
              <Button
                className="fillbutton"
                type="submit"
                disabled={!isFormValidOTP}
              >
                {isOTPLoading ? (
                  <>
                    <SpinnerLoader />
                  </>
                ) : (
                  "Verify"
                )}
              </Button>
            </div>
            <div className="d-flex justify-content-center mt-3">
              <p>
                {timer === 0 ? (
                  <Link
                    to="#"
                    className="text-overline2"
                    onClick={handleResendOTP}
                  >
                    Resend Code
                  </Link>
                ) : (
                  `Resend code in ${timer} seconds`
                )}
              </p>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* OTP Modalbox */}
      </section>
    </>
  );
}

export default Welcome;
